<div class="ui-modal">
  <div class="header flex-row space-between-center">
    {{ 'PERSONS.SAVE_NEW_PERSON' | translate }}
    <span class="ui-icon-close c-p" (click)="closeDialog()"></span>
  </div>
  <div class="body flex-col start-start flex gap-16 dialog-content narrower-input">
    <app-person-details-form
      [formControl]="personNameForm"
      [imageUrl]="getImagePath(person)"
      [imageUrlFallback]="getImagePath(person, false)"
    ></app-person-details-form>
  </div>
  <div class="footer flex-row end-center gap-8">
    <ui-button
      type="secondary"
      [text]="'PERSONS.ADD_TO_GROUP' | translate"
      [disabled]="!isPersonNameValid()"
      (clickAction)="openAddPersonToGroupsDialog()"
    ></ui-button>
    <ui-button
      type="primary"
      [text]="'COMMON.SAVE' | translate"
      [disabled]="!isPersonNameValid() || !recognitionResult?.positiveTrackerIds?.length || !unsavedPersonsToken()"
      [loading]="isCreating()"
      (clickAction)="savePerson()"
    ></ui-button>
  </div>
</div>
